<script lang="ts">
    import { Collection } from "sveltefire";
    import {
        ProgressCircular,
        Card,
        CardTitle,
        Divider,
        CardSubtitle,
        CardText,
        Container,
        Row,
        Col,
    } from "svelte-materialify/src";
</script>

<h6 class="text-h6 primary-text">Experience</h6>

<Collection
    path={"experiences"}
    traceId={"experiencesRead"}
    let:data={experiences}
    query={(ref) => ref.orderBy("start", "desc")}
>
    <Container>
        <Row>
            {#each experiences as { job, company, location, notes }}
                <Col cols={12} xl={4} lg={4} md={4} sm={12}>
                    <Card outlined>
                        <CardTitle class="remove-break">{job}</CardTitle>
                        <Divider />
                        <CardSubtitle class="remove-break"
                            >{company} - {location}</CardSubtitle
                        >
                        <CardText class="remove-break">
                            {#each notes as note}
                                <p>{note}</p>
                            {/each}
                        </CardText>
                    </Card>
                </Col>
            {/each}
        </Row>
    </Container>
    <span slot="loading">
        <ProgressCircular indeterminate color="primary" /></span
    >
    <span slot="fallback" class="primary-text">Error loading data</span>
</Collection>
